import React from 'react';

const LocationContext = React.createContext(null);

export default LocationContext;